import React, { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

/**
 * Live local clock (hh:mm:ss AM/PM). Keeps its own ticking state so the
 * navbar around it doesn't re-render every second.
 */
const NavbarClock = () => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const h = now.getHours();
  const hh = pad(h % 12 || 12);
  const mm = pad(now.getMinutes());
  const ss = pad(now.getSeconds());
  const ampm = h < 12 ? "AM" : "PM";
  const fullDate = now.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" });

  return (
    <div
      title={fullDate}
      className="hidden md:flex items-center gap-2 h-9 px-3 rounded-[10px] border border-line bg-panel whitespace-nowrap"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-ok animate-clock-pulse" style={{ boxShadow: "0 0 8px var(--green)" }} />
      <span className="font-mono text-[13.5px] font-medium tracking-[0.02em] tabular-nums text-ink">
        {hh}:{mm}
        <span className="text-accent-ink">:{ss}</span>
      </span>
      <span className="text-[11px] font-semibold text-faint">{ampm}</span>
    </div>
  );
};

export default NavbarClock;
